/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const CopyToExceptionIconOutline = createIcon({
  displayName: 'CopyToExceptionIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M3,19v1.14286A.85745.85745,0,0,0,3.85714,21H5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M13,9h1.14286A.85745.85745,0,0,1,15,9.85714V11"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M10,21H8"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M10,9H8"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M13,21h1.14286A.85745.85745,0,0,0,15,20.14286V19"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M3,11V9.85714A.85745.85745,0,0,1,3.85714,9H5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M15,14v2"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M3,14v2"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M8,6V5a1.99945,1.99945,0,0,1,2-2h9a1.99945,1.99945,0,0,1,2,2v9a1.99945,1.99945,0,0,1-2,2H18"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path d="M0,0H24V24H0Z" fill="none" />
    </>
  ),
})

const CopyToException: FC<CustomIconProps> = (props) => {
  return <CustomIcon as={CopyToExceptionIconOutline} {...props} />
}

export default memo(CopyToException)
